import { render } from "./ClienteCadastro.vue?vue&type=template&id=1b955633&ts=true"
import script from "./ClienteCadastro.vue?vue&type=script&lang=ts"
export * from "./ClienteCadastro.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__